class AlgoliaIconCaretLeft extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconCaretLeftUrl: this.getAttribute('default-icon-caret-left-url'),
      iconCaretLeftImageSize: this.getAttribute('icon-caret-left-image-size'),
      iconCaretLeftIsImage: this.getAttribute('icon-caret-left-is-image').toLowerCase() === 'true',
      iconCaretLeftSize: this.getAttribute('icon-caret-left-size'),
      iconCaretLeftUrl: this.getAttribute('icon-caret-left-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .aa-Autocomplete .icon-caret-left {
        height: 1.8rem;
        width: 1.8rem;
        background-repeat: no-repeat;
      }

      ${this.settings.iconCaretLeftIsImage ? `
        :is(.slider-buttons, .slider-buttons-sides) button:disabled {
          opacity: 0;
        }

        .aa-Autocomplete .slider-button {
          width: ${this.settings.iconCaretLeftImageSize}px;
          height: ${this.settings.iconCaretLeftImageSize}px;
        }

        .aa-Autocomplete .icon-caret-left {
          background-image: url(${this.settings.iconCaretLeftUrl ? this.settings.iconCaretLeftUrl : this.settings.defaultIconCaretLeftUrl});
        }
      ` : `
        .aa-Autocomplete .icon-caret-left {
          -webkit-mask-image: url(${this.settings.iconCaretLeftUrl ? this.settings.iconCaretLeftUrl : this.settings.defaultIconCaretLeftUrl});
          background-color: var(--color-core-100);
          -webkit-mask-size: ${this.settings.iconCaretLeftSize}%;
          -webkit-mask-position: center;
          -webkit-mask-repeat: no-repeat;
        }
      `}
    `;

    style.appendChild(document.createTextNode(css));

    return style;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('icon-caret-left');
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('focusable', 'false');
    div.textContent = ' ';

    return [style, div];
  }
}

customElements.define("algolia-icon-caret-left", AlgoliaIconCaretLeft);